module.exports = __webpack_public_path__ + "static/media/ForwardArrow2.f0b97760.svg";